import { render, staticRenderFns } from "./vue-myseed-certificate.vue?vue&type=template&id=ee520298&scoped=true&"
import script from "./vue-myseed-certificate.vue?vue&type=script&lang=js&"
export * from "./vue-myseed-certificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee520298",
  null
  
)

export default component.exports